import gql from "graphql-tag";

const ALERT_LOG_FIELDS = gql`
  fragment AlertLogFields on AlertLogs {
    id
    bookingId
    sanctionedPlateId
    contactId
    alertType
    providerType
    status
    providerMessageId
    errorCode
    errorMessage
    sentAt
    deliveredAt
    failedAt
    createdAt
    updatedAt
    booking {
      id
      plate
      guestName
      guestEmail
      guestPhone
      startDay
      endDay
      status
      rateCard {
        name
      }
    }
    sanctionedPlate {
      id
      plate
    }
    contact {
      id
      name
      email
      phone
    }
  }
`;

export const alertLogsQuery = gql`
  query AlertLogs($installationId: ID!, $search: String, $offset: Int!, $limit: Int!) {
    alertLogs(installationId: $installationId, search: $search, offset: $offset, limit: $limit) {
      count
      items {
        ...AlertLogFields
      }
    }
  }
  ${ALERT_LOG_FIELDS}
`;
